import {FilterSpec} from './filter-spec'

export class Filter {

  public static applyFilters(filterSpecs: Array<FilterSpec>, obj: Array<any>) {
    let objectIsPartOfFiltrate = false

    return obj.filter((objectToFilter) => {
      return filterSpecs.some((filter) => {
        objectIsPartOfFiltrate = Filter.isPartOfFiltrate(filter.getAsValueFilter(), objectToFilter);
        if (objectIsPartOfFiltrate && filter.hasSubFilters()) {
          filter.subFilters.forEach((subFilter) => {
            if (subFilter.hasSubFilters() && !subFilter.hasValueFilter()) {
              objectToFilter[subFilter.attr] = Filter.applyFilters(subFilter.subFilters, objectToFilter[subFilter.attr]);
              objectIsPartOfFiltrate = objectIsPartOfFiltrate && objectToFilter[subFilter.attr].length > 0
            }
          })
        }
        return objectIsPartOfFiltrate
      })
    })
  }

  public static applyFilter(filterSpec: FilterSpec, obj: any) {
    if (Filter.isPartOfFiltrate(filterSpec, obj)) {
        return obj
    }
    return undefined
  }

  public static isPartOfFiltrate(filterSpec: FilterSpec, obj: any) {
    if (!Filter.isFilterSpecApplicable(filterSpec, obj)) {
        return false
    }

    let filterResult = true;
    if (filterSpec.hasValueFilter()) {
      filterResult = typeof filterSpec.value === 'function'
        ? filterSpec.value(obj[filterSpec.attr])
        : Filter.isEqual(obj[filterSpec.attr], filterSpec.value)
    }

    if (filterResult && filterSpec.hasSubFilters()) {
      filterResult = filterResult && filterSpec.subFilters.some((filter) => {
        return Filter.apply(filter, obj[filter.attr])
      })
    }
    return filterResult
  }

  public static isFilterSpecApplicable(filterSpec, obj) {
    return typeof filterSpec.attr !== 'undefined' && filterSpec.attr in obj;
  }

  public static isEqual(obj, value) {
    if (Array.isArray(obj)) {
      return obj.every((valueToFilter) => {
        return valueToFilter === value
       })
    } else {
      return obj === value;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/filter.ts